export default __webpack_public_path__ + "static/media/(29).a3fed44b.jpg";